// client/src/components/MultiLocationUserPartner.js
import PropTypes from "prop-types";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";

const MultiLocationUserPartner = ({
  locations = [],
  selectedLocations = [],
  onChange = () => {},
  label = "Locations",
}) => {
  const handleChange = (_, newValues) => {
    // Pass only real selections; empty array means ALL
    onChange(newValues || []);
  };

  return (
    <Autocomplete
      multiple
      options={locations}
      value={selectedLocations}
      getOptionLabel={(o) => o?.name || ""}
      isOptionEqualToValue={(a, b) => a?._id === b?._id}
      onChange={handleChange}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <>
                {(!selectedLocations || selectedLocations.length === 0) && (
                  <Chip size="small" label="ALL" disabled sx={{ mr: 0.5 }} color="info" />
                )}
                {params.InputProps.startAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

MultiLocationUserPartner.propTypes = {
  locations: PropTypes.instanceOf(Array),
  selectedLocations: PropTypes.instanceOf(Array),
  onChange: PropTypes.func,
  label: PropTypes.string,
};

export default MultiLocationUserPartner;
